import Phaser from 'phaser';
import { MenuScene } from './scenes/MenuScene';
import { GameScene } from './scenes/GameScene';
import { VideoPokerScene } from './scenes/VideoPokerScene';
import { TexasHoldemScene } from './scenes/TexasHoldemScene';
import { AdminPanel } from './ui/AdminPanel';
import { ThemeSelector } from './components/ThemeSelector';
import { UserManager } from './components/UserManager';
import { UserLoginModal } from './components/UserLoginModal';
import { ApiAuth } from './components/ApiAuth';

// Initialize API authentication
const apiAuth = ApiAuth.getInstance();

async function initializeApp() {
    const isAuthenticated = await apiAuth.initialize();
    if (!isAuthenticated) {
        return;
    }

    initializeGame();
}

function initializeGame() {
// Detect if mobile device
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const isLandscape = window.innerWidth > window.innerHeight;

// Adjust game dimensions based on device
const gameWidth = isMobile ? (isLandscape ? 1024 : 800) : 1280;
const gameHeight = isMobile ? (isLandscape ? 600 : 900) : 665;

const config: Phaser.Types.Core.GameConfig = {
    type: Phaser.AUTO,
    parent: 'game-container',
    width: gameWidth,
    height: gameHeight,
    scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        min: {
            width: 320,
            height: 480
        },
        max: {
            width: 1920,
            height: 1080
        }
    },
    backgroundColor: '#1a0033',
    scene: [MenuScene, GameScene, VideoPokerScene, TexasHoldemScene],
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { x: 0, y: 0 }
        }
    },
    input: {
        touch: {
            target: null,
            capture: false
        }
    }
};

const game = new Phaser.Game(config);

const adminPanel = new AdminPanel();
adminPanel.init();

// Initialize user system
const userManager = UserManager.getInstance();
userManager.migrateOldHighScores(); // Migrate any existing data

// Note: Selectors are now managed by individual scenes

// Set authenticated user in UserManager
const authenticatedUser = apiAuth.getUser();
if (authenticatedUser) {
    userManager.setAuthenticatedUser({
        id: authenticatedUser.id.toString(),
        name: authenticatedUser.name,
        displayName: authenticatedUser.name,
        isAuthenticated: true,
        balance: authenticatedUser.balance,
        isAdmin: authenticatedUser.isAdmin
    });
}

// No login modal needed - user is already authenticated via API key

if (window.location.hash === '#debug') {
    (window as any).game = game;
    (window as any).adminPanel = adminPanel;
    (window as any).userManager = userManager;
}

window.addEventListener('resize', () => {
    game.scale.refresh();
});

// Add orientation change handler for mobile
if (isMobile) {
    window.addEventListener('orientationchange', () => {
        setTimeout(() => {
            game.scale.refresh();
            window.scrollTo(0, 0);
        }, 100);
    });
    
    // Show landscape prompt for portrait mode on mobile
    const checkOrientation = () => {
        if (window.innerHeight > window.innerWidth && isMobile) {
            // Optional: You could show a message suggesting landscape
            console.log('For best experience, please rotate your device to landscape mode');
        }
    };
    
    window.addEventListener('orientationchange', checkOrientation);
    checkOrientation();
}
}

// Start the app
initializeApp();